module.exports = __webpack_public_path__ + "img/laurent-chocron.9eced272.jpg";